import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type OTPCredentialsDTO = {
    OTP: string;
    email: string;
};
export const verifyotp = (data: OTPCredentialsDTO): Promise<ApiError> => {
    return axios.post("/student/verifyToken", data);
};
